export default __webpack_public_path__ + "static/media/Mies.9dfc89ef.jpg";